module.exports = __webpack_public_path__ + "img/residence.9ca6d25d.jpg";